import { Route, Routes, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import styles from './App.module.css';
import HomePage from './pages/homePage/HomePage';
import TermsPage from './pages/termsPage/TermsPage';
import PrivacyPage from './pages/privacyPage/PrivacyPage';
import {
  Languages,
  getDefaultLanguageHandler,
  SelectedLanguage,
  LanguageSelector,
  Cookie,
  PrivacySettings,
  Navbar
} from 'abu-common-components';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import Spinner from './components/UI/spinner/Spinner';
import { trackPromise } from 'react-promise-tracker';
import { getBookingAdminToolConfig } from './apiCall';
function App() {
  const { i18n } = useTranslation();
  const defaultLanguage = getDefaultLanguageHandler(i18n, Languages);
  const [language, setLanguage] = useState(defaultLanguage);
  const [openLanguageModal, setOpenLanguageModal] = useState(false);
  const [showCookie, setShowCookie] = useState(false);
  const [openPrivacySettings, setOpenPrivacySettings] = useState(false);
  const [showCompletePageContent, setShowCompletePageContent] = useState(false);
  const { pathname } = useLocation();
  const isLegalPage = pathname === '/terms' || pathname === '/privacy';
  const navBarClassName = classnames(styles.navBar, {
    [styles.navBarTerms]: isLegalPage
  });
  const languageHoverStyle = isLegalPage
    ? {
        onHoverLanguage: '#FFFFFF',
        backgroundColorLanguage: 'rgba(0,0,0,0.06)'
      }
    : {
        onHoverLanguage: 'rgba(0,0,0,0.06)',
        backgroundColorLanguage: '#FFFFFF'
      };

  useEffect(() => {
    const getAdminConfig = async () => {
      await trackPromise(
        getBookingAdminToolConfig()
          .then((res) => {
            if (res && res.settings.enableAdvanceFunctionallity) {
              setShowCompletePageContent(res.settings.enableAdvanceFunctionallity);
            } else {
              setShowCompletePageContent(false);
            }
          })
          .catch((error) => {
            error && setShowCompletePageContent(false);
          })
      );
    };
    getAdminConfig();
  }, []);

  return (
    <div className={styles.container} data-testid="appTestId">
      {openLanguageModal && showCompletePageContent && (
        <div role="dialog">
          <LanguageSelector
            availableLanguages={Languages}
            changeLanguage={setLanguage}
            language={language}
            toggleLanguageModal={setOpenLanguageModal}
          />
        </div>
      )}
      {openPrivacySettings && <PrivacySettings togglePrivacySetting={setOpenPrivacySettings} />}
      {showCompletePageContent && (
        <header>
          <a tabIndex={1} href="#accessReservation" className={styles.skipToMainContentLink}>
            Skip to main content
          </a>
          <div className={navBarClassName} data-testid="navBarTestId">
            <div className={styles.headerLogo}>
              {' '}
              <Navbar />{' '}
            </div>
            <div className={styles.selectedLanguageContainer}>
              <SelectedLanguage
                language={language}
                changeLanguageModal={setOpenLanguageModal}
                hoverStyle={languageHoverStyle}
              />
            </div>
          </div>
        </header>
      )}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path={'/terms'} element={<TermsPage />} />
        <Route path={'/privacy'} element={<PrivacyPage />} />

        <Route path="*" element={<HomePage />} />
      </Routes>
      {showCookie && (
        <Cookie toggleCookie={setShowCookie} togglePrivacySettings={setOpenPrivacySettings} />
      )}
      <Spinner />
    </div>
  );
}

export default App;
